import React from 'react';
import { Pool } from 'src/services/pool';
import { toReadableNumber } from './numbers';
import Big from 'big.js';
import { TokenMetadata } from 'src/services/ft-contract';

export const getLiquidity = (
  pool: Pool,
  tokenIn: TokenMetadata,
  tokenOut: TokenMetadata
) => {
  const tokenInReserve = toReadableNumber(
    tokenIn.decimals,
    pool.supplies[tokenIn.id]
  );
  const tokenOutReserve = toReadableNumber(
    tokenOut.decimals,
    pool.supplies[tokenOut.id]
  );

  const reserveProduct = new Big(tokenInReserve).times(
    new Big(tokenOutReserve)
  );

  return Number(reserveProduct);
};
